module.exports = __webpack_public_path__ + "img/logo_head.ef71f3f1.png";